import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import CatalogObject from '@square/dashboard-items-data/models/squareup/inventory/v3/catalog-object';
import Money from '@square/dashboard-money/models/money';
export default CatalogObject.extend({
  intl: service(),
  name: computed('attribute.[]', function () {
    return this.getAttrStringValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS.name.token) || '';
  }),
  percentage: computed('attribute.[]', function () {
    const percentage = this.getAttrIntValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS.percentage.token);
    if (percentage === null) {
      return null;
    }
    return percentage / 100000;
  }),
  amount: computed('attribute.[]', function () {
    const amount = this.getAttrIntValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS['price.cents'].token);
    if (amount === null) {
      return null;
    }
    const currencyCode = this.getAttrStringValueByDefToken(CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS['price.currency_code'].token);
    return Money.fromCents(amount, currencyCode);
  }),
  formattedTax: computed('amount.{amount,formatted}', 'name', 'percentage', function () {
    const percentage = this.percentage;
    const amount = this.amount?.formatted;
    const name = this.name;
    if (percentage) {
      return `${name} (${percentage}%)`;
    } else if (amount && this.amount?.amount !== 0) {
      return `${name} (${amount})`;
    } else {
      return this.intl.t('inventory2.purchaseOrders.editSheet.headers.tax');
    }
  })
});